/**
 * Schema of AlertaCarga
 * @author Simpli CLI generator
 */
import {cnpj, cpfOrCnpj, Schema} from 'simpli-web-sdk'
import DeliveryShipperResponse from '@/model/response/DeliveryShipperResponse'
import RenderNumber from '@/components/render/RenderNumber.vue'

export default (model: DeliveryShipperResponse): Schema => ({

  nome: {
    content: model.nome,
  },

  documento: {
    content: cpfOrCnpj(model.documento),
  },

  qtdSemOcorrencia: {
    content: {
      component: RenderNumber,
      props: {
        number: model.qtdSemOcorrencia,
      },
    },
    textContent: model.qtdSemOcorrencia || '0',
  },

  qtdComOcorrencia: {
    content: {
      component: RenderNumber,
      props: {
        number: model.qtdComOcorrencia,
      },
    },
    textContent: model.qtdComOcorrencia || '0',
  },

  qtdDevolvidas: {
    content: {
      component: RenderNumber,
      props: {
        number: model.qtdDevolvidas,
      },
    },
    textContent: model.qtdDevolvidas || '0',
  },

  qtdTotal: {
    content: {
      component: RenderNumber,
      props: {
        number: model.qtdTotal,
      },
    },
    textContent: model.qtdTotal || '0',
  },

})
